import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserGroupManagerViewComponent } from './views/user-group-manager-view/user-group-manager-view.component';
import { SharedModule } from '@shared/shared.module';
import { UserGroupsListComponent } from './containers/user-groups-list/user-groups-list.component';
import { UserGroupAppLinksComponent } from './containers/user-group-app-links/user-group-app-links.component';
import { UserGroupLinkedAppAuthorizationsEditorComponent } from './containers/user-group-linked-app-authorizations-editor/user-group-linked-app-authorizations-editor.component';
import { NavigationItemTreeModule } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-tree.module';
import { UserGroupLinkedUsersEditorComponent } from './containers/user-group-linked-users-editor/user-group-linked-users-editor.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTreeModule } from '@angular/material/tree';
import { UserGroupsFilterComponent } from './components/user-groups-filter/user-groups-filter.component';
import { PlatformManagementDataModule } from '@/app/platform/platform-data/platform-management-data.module';
import { FeatureRestrictionsIndicatorsComponent } from './components/feature-restrictions-indicators/feature-restrictions-indicators.component';
import { FeatureAccessTogglerComponent } from './components/feature-access-toggler/feature-access-toggler.component';
import { FormlyModule } from "@ngx-formly/core";

@NgModule({
  declarations: [
    UserGroupManagerViewComponent,
    UserGroupsListComponent,
    UserGroupAppLinksComponent,
    UserGroupLinkedAppAuthorizationsEditorComponent,
    UserGroupLinkedUsersEditorComponent,
    UserGroupsFilterComponent,
    FeatureRestrictionsIndicatorsComponent,
    FeatureAccessTogglerComponent
  ],
  exports: [UserGroupManagerViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    PlatformManagementDataModule,
    NavigationItemTreeModule,
    NgSelectModule,
    MatTreeModule,
    FormlyModule
  ]
})
export class UserGroupBlockModule {}
